import axios from "axios";
import { useEffect, useState } from "react";
import axiosInstant from "../../../axiosInstant";
import { mergeUniqueBy } from "../../../utils/collection";

export default function LotData(page, searching) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [lotdata, setLot] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  // I-reset ang lahat kapag may bagong search
  useEffect(() => {
    setLot([]);
    setHasMore(true);
    setError(false);
    setErrorMsg("");
  }, [searching]);

  useEffect(() => {
    // 1. STOP: Wag mag-fetch kung alam na nating wala nang records
    if (!hasMore) return;

    setLoading(true);
    setError(false);
    let cancel;

    const fetchData = async () => {
      try {
        const res = await axiosInstant({
          method: "GET",
          url: `search?search=${searching || ""}&page=${page || 1}`,
          cancelToken: new axios.CancelToken((c) => (cancel = c)),
        });

        // 2. CHECK: Kung ang response ay success pero walang laman
        if (res.data.count === 0 || !res.data.msg || res.data.msg.length === 0) {
          setHasMore(false);
          setLoading(false);
        } else {
          setLot((prevlotdata) =>
            mergeUniqueBy(prevlotdata, res.data.msg, (item) => item.data.id)
          );
          setHasMore(true);
          setLoading(false);
        }
      } catch (e) {
        if (axios.isCancel(e)) return;

        const errMsg = e?.response?.data?.msg;
        
        // 3. LOGIC: Kung ang error message ay "no record found", 
        // ibig sabihin dulo na ng listahan kaya i-off na ang hasMore.
        if (errMsg === "no record found" || e?.response?.data?.sucess === false) {
          setHasMore(false); // Patigilin na ang scroll fetch
          setError(false);   // Huwag ituring na "red error" dahil dulo lang talaga ito
        } else {
          setErrorMsg(errMsg || "Error fetching data");
          setError(true);
        }
        
        setLoading(false);
      }
    };

    fetchData();
    return () => cancel && cancel();
  }, [page, searching]); // Mag-re-run lang pag nagbago ang page o search

  return { loading, error, lotdata, setLot, hasMore, errorMsg };
}